module.exports = function generateJsonApiIncludes(config) {
	let includeApi = "";
	if (
		config.relationships &&
		Array.isArray(config.relationships) &&
		config.relationships.length > 0
	) {
		includeApi += "include=";
		includeApi += config.relationships.join(",");
	}
	return includeApi;
};
